import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {GetHealthVerifySpecialties} from 'domain/usecases/private/booking-flow/health/get-health-verify-specialties';
import {RemoteGetVerifySpecialties} from 'data/usecases/private/booking-flow/health/remote-get-health-verify-specialties';

export const makeGetHealthVerifySpecialties = (): GetHealthVerifySpecialties =>
	new RemoteGetVerifySpecialties(
		makeBFFApiUrl(BookingFlowEndPoints.healthVerifySpecialties),
		makeAuthorizeHttpClientDecorator(),
	);
